import { InputLabel, MenuItem } from '@mui/material';
import { memo, useEffect } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { FeatureAuth } from 'shell/models/feature-auth';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface FeatureAuthValueListProps {
  disabled?: boolean;
  value: string;
  onChange: (id: string, value: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
  idFeatureAuth: string;
}

const FeatureAuthValueListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Valore',
  id = 'typeFeatureValue',
  idFeatureAuth,
}: FeatureAuthValueListProps): React.ReactElement => {
  const [featureAuthValue, getFeatureAuthValue] = useHttpFetch<
    HttpResponse<FeatureAuth>,
    Array<ItemVM>
  >(`${__MANAGEMENT_API_URL__}/tipo-feature-auth/${idFeatureAuth}`, {
    options: {
      method: 'GET',
      abortable: true,
      errorCatching: false,
      loading: false,
    },
    onBootstrap: false,
    transformer: (response) => {
      const data = response.data.payload;
      return data.featureValoreList.map((item) => {
        return {
          id: `${item.key?.codiceFeature}.${item.key?.valoreAmmesso}`,
          value: `${item.key?.valoreAmmesso} - ${item.descrizioneValoreAmmesso}`,
        };
      });
    },
  });

  useEffect(() => {
    if (!disabled && idFeatureAuth) {
      getFeatureAuthValue();
    }
  }, [idFeatureAuth, disabled]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) =>
          onChange(
            event.target.value,
            (featureAuthValue?.data as Array<ItemVM>).find(
              (item: ItemVM) => item.id === event.target.value
            )?.value || ''
          )
        }
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {featureAuthValue?.data
          ? (featureAuthValue?.data as Array<ItemVM>)
              .sort((a, b) => a.value?.localeCompare(b.value))
              .map((item: ItemVM) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.value}
                </MenuItem>
              ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

FeatureAuthValueListComponent.displayName = 'Feature Auth Value list component';

const FeatureAuthValueList = memo(FeatureAuthValueListComponent);

export default FeatureAuthValueList as typeof FeatureAuthValueListComponent;
